<template>
  <div class="control-pad new-control-pad">
    <div
    v-if="!is_vip && dialogToastCnt > 3 && is_huisuo_disco"
    class="top-effect"
    @click="jump()"
    v-log="{
      event_type: 'show',
      event_name: '蹦迪入口展示',
      event_data: {
        action: '遥控页'
      }
    }"
    ><img src="https://qncweb-back1.ktvsky.com/20220707/other/799c08d93d14473cec4e29338e2f2749.png" alt=""></div>
    <div class="control-wrapper">
      <AD v-if="is_vip&&!have_gift" class="ad-style"
          position="playControl"
          imgType="toast"
          containerClass=".control-wrapper .container"></AD>
      <div class="container">
        <div class="pad-wrap">
          <div v-if="isSupportInteract" class="increment-box">
              <VipPackages v-if="!['role1'].includes(role)"/>
              <send-gift v-else-if="have_gift && !isBlockInteractText" />
          </div>
          <div class="operate-box" :class="{
            'operate-box-vip': is_vip,
            'operate-box-role5': role === 'role5',
          }">
            <div v-if="role === 'role5' && false" class="mask-box" @click="handleMask">
              <img src="https://qncweb.ktvsky.com/20260304/vadd/a543eae5ccef51d49b1c33aaa7640fe2.png" alt="欢乐歌房">
            </div>
            <div class="top-cancel-btn" @click.stop="closePad">
              <img src="https://qncweb-back1.ktvsky.com/20240828/vadd/e9baccf14ec131a5c998945763e685f5.png" alt="关闭">
            </div>
            <div class="operate-btn">
              <div class="row row-first">
                <div v-for="(item, index) in newOperateArr.slice(0, 3)" :key="index" class="control-btn" @click="handleOperate(item.type)">
                  <img v-if="item.icon" :src="item.icon" alt="">
                </div>
              </div>
              <div class="row row-second">
                <div class="control-btn" @click="handleOperate(newOperateArr[3].type)">
                  <img v-if="newOperateArr[3].icon" :src="newOperateArr[3].icon" alt="">
                </div>
                <div class="voice voice-speaker">
                  <button @click="handleOperate('mvol', 0)"></button>
                  <img :src="volumeControl[1].newUrl" class="volume-name">
                  <button @click="handleOperate('mvol', 1)"></button>
                </div>
              </div>
              <div class="row row-third">
                <div class="control-btn" @click="handleOperate(newOperateArr[4].type)">
                  <img v-if="newOperateArr[4].icon" :src="newOperateArr[4].icon" alt="">
                </div>
                <div class="voice voice-microphone">
                  <button @click="handleOperate('mmic', 0)"></button>
                  <img :src="volumeControl[0].newUrl" class="volume-name">
                  <button @click="handleOperate('mmic', 1)"></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  chttp, http, apis, Stat,
} from '@/libs/interfaces';
import { mapState } from 'vuex';
import AD from '@/components/app/ad';
import get from 'lodash/get';
import { reportPay } from '@/libs/utils/log/log';
import VipPackages from './vip_packages.vue';
import SendGift from './send-gift.vue'

const CONTROL_DESC = {
  next: {
    desc: '切歌',
    tip: '切歌成功',
  },
  reset: {
    desc: '重唱',
    tip: '已重唱',
  },
  ptoggle: {
    desc: '播/停',
    tip: '切换成功',
  },
  ctoggle: {
    desc: '原/伴',
    tip: '切换成功',
  },
  control: {
    desc: '评分',
    tip: '切换成功',
  },
  mmic: {
    desc: '麦克风',
    tip: '麦克风调音成功',
  },
  mvol: {
    desc: '音响',
    tip: '音响调音成功',
  },
}

export default {
  name: 'controlPad',
  props: ['isFooter'],
  components: {
    AD,
    VipPackages,
    SendGift,
  },
  data() {
    return {
      volumeControl: [
        {
          name: '麦克',
          qnurl: 'https://qncweb-back1.ktvsky.com/20220802/vadd/ccbc3028a0d2fa9a92ec28dbe91e5594.png',
          value: 'mmic',
          newUrl: 'https://qncweb.ktvsky.com/20260113/vadd/b5cf69e5b9cc09ac258c750648a1bb57.png'
        }, {
          name: '音响',
          qnurl: 'https://qncweb-back1.ktvsky.com/20220802/vadd/6a75c12a1987d5c5aa8ea753ad3b6eb5.png',
          value: 'mvol',
          newUrl: 'https://qncweb.ktvsky.com/20260113/vadd/54341546ab61aa837b28c59b1ce720eb.png'
        },
      ],
      score: 0,
      nextSong: {
        status: 'init',
      },
      nextMySong: {},
      mySongTime: '',
      isShowCheap: false,
      dialogToastCnt: 0,
      announcerStatus: 0, // 是否显示报幕开关
      announcerAction: 1, // 是否打开报幕开关
      announcerDefault: 0, // 报幕开关初始设置
      gifts: [],
      giftIndex: null,
    };
  },
  computed: {
    ...mapState({
      openid: (state) => state.openid,
      unionid: (state) => state.unionid,
      bless_path: (state) => state.bless_path,
      is_bind: (state) => state.bind_status,
      have_mic: (state) => state.have_mic,
      have_bullet: (state) => state.have_bullet,
      have_mv: (state) => state.have_mv,
      have_photo: (state) => state.have_photo,
      have_gift: (state) => state.have_gift,
      is_vip: (state) => state.is_vip,
      have_emoji: (state) => state.have_emoji,
      have_score: (state) => state.have_score,
      have_video: (state) => state.have_video,
      goldMessage: (state) => state.goldMessage,
      user_name: (state) => state.user_name,
      isCheapVip: (state) => state.is_low_price, // 是否开通过vip低价会员
      is_huisuo_disco: (state) => state.is_huisuo_disco,
      isSupportInteract: (state) => state.isSupportInteract,
      ktvid: (state) => state.ktvid,
      Mac: (state) => state.Mac,
      roomid: (state) => state.roomid,
      isBlockInteractText: (state) => state.isBlockInteractText,
      is_leike_device: (state) => state.is_leike_device,
      role: (state) => state.role,
      headimg() {
        return this.$store.state.user_img || require('../../../views/vip/static/head.png');
      },
      goldImg() {
        return this.goldMessage.headimgurl || require('../../../views/vip/static/head.png');
      },
      incrementArr() {
        return [
          { name: '炫彩弹幕', url: 'barrage', text: 'barrage' },
          { name: '聊骚表情', url: '/thunder/expression', text: 'expression' },
          { name: '动感礼物', url: 'gift', text: 'gift' },
          { name: '喝酒游戏', url: 'action/drink_game', text: 'drink' },
        ];
      },
      vipIcon() {
        return this.goldMessage.userid && this.goldMessage.userid === this.nextSong.userid
        ? 'https://qncweb-back1.ktvsky.com/20220302/vadd/5a06e13d1e4fa33cbfeeb2ceb11851cd.png'
        : 'https://qncweb-back1.ktvsky.com/20220302/vadd/ccf8de8af963978c309fd7246358e54a.png'
      },
      nextSongName() {
        return this.nextSong.music_name || this.nextSong.musicname || '歌曲加载中...'
      },
      operateArr() {
        const haveAnnouncerOperate = [
          { name: '播/停', text: 'ptoggle', icon: 'https://qncweb-back1.ktvsky.com/20220302/vadd/f6b4ca0b6fb945fe2a8ca0a01e6ab5da.png' },
          { name: '原/伴', text: 'ctoggle', icon: 'https://qncweb-back1.ktvsky.com/20220302/vadd/dc9b1415d1e3e412b94d237d9aed0e7b.png' },
          { name: '重唱', text: 'reset' },
          { name: '评分', text: 'control' },
          { name: '报幕', text: 'announcer' },
        ]
        const noAnnouncerOperate = [
          { name: '重唱', text: 'reset', icon: 'https://qncweb-back1.ktvsky.com/20220302/vadd/2dd3a316cb099284c2749d1800ae1d5a.png' },
          { name: '原/伴', text: 'ctoggle', icon: 'https://qncweb-back1.ktvsky.com/20220302/vadd/dc9b1415d1e3e412b94d237d9aed0e7b.png' },
          { name: '评分', text: 'control', icon: 'https://qncweb-back1.ktvsky.com/20220302/vadd/9d1e99d8cc5eb5750e8bfe951b0a8aab.png' },
          { name: '播/停', text: 'ptoggle', icon: 'https://qncweb-back1.ktvsky.com/20220302/vadd/f6b4ca0b6fb945fe2a8ca0a01e6ab5da.png' },
        ]
        return this.announcerStatus == 1 ? haveAnnouncerOperate : noAnnouncerOperate
      },
      newOperateArr() {
        return [
          {
            name: '播/停',
            type: 'ptoggle',
            text: '播放/暂停',
            icon: 'https://qncweb.ktvsky.com/20260113/vadd/31d583ab19933a7632e4740172505ae3.png'
          }, {
            name: '原/伴',
            type: 'ctoggle',
            text: '原唱/伴唱',
            icon: 'https://qncweb.ktvsky.com/20260113/vadd/cccd104a1be908ac3d44dbabcf4bedb4.png'
          }, {
            name: '切歌',
            type: 'next',
            text: '切歌',
            icon: 'https://qncweb.ktvsky.com/20260113/vadd/8757a2949a3282249bfc7819b687027f.png'
          }, {
            name: '重唱',
            type: 'reset',
            text: '重唱',
            icon: 'https://qncweb.ktvsky.com/20260113/vadd/043e67244a74c1a67280bfd80bfcc62c.png'
          }, {
            name: '评分',
            type: 'control',
            text: '评分',
            icon: 'https://qncweb.ktvsky.com/20260113/vadd/2c1e11c34b0204f58bc95ddf3ce38ccb.png'
          },
        ];
      },
    }),
  },
  methods: {
    jump() {
      this.$sendLog({
        event_type: 'click',
        event_name: '蹦迪入口点击',
        event_data: {
          action: '遥控页',
        },
      });
      this.$router.push('/thunder/disco?fromType=control')
    },
    closePad() {
      this.$store.commit('SET_CONTROL_PAD', false);
    },
    handleOrder() {
      this.$store.commit('SET_CONTROL_PAD', false);
      this.$router.push('/thunder/ordered?fromType=controlPad')
    },
    handleIncrement(item) {
      if (!this.is_bind && item.text !== 'charge') {
        return this.$store.commit('SAVE_SHOW_SCODE_BOX', true);
      }
      let path = item.url;
      this.closePad();
      Stat({ tp: '遥控控件', desc: item.name });
      _hmt.push(['_trackEvent', '遥控控件', `点击${item.name}按钮`, 'controlPad']);
      if (new RegExp('action', 'i').test(path)) {
        if (new RegExp('drink_game', 'i').test(path)) {
          if (this.have_gift) {
            path = 'action/game_collection';
          }
        }
        location.href = process.env.BASE_URL + path;
        return;
      }
      const { text } = item;
      if (text === 'charge') {
        this.$router.push(path);
      }
      // 弹幕与表情判断是否是vip
      if (text === 'barrage' || text === 'expression') {
        if (!this.is_vip) {
          this.$router.push('/thunder/openvip?fromType=controlPad');
        } else {
          this.$router.push('/thunder/interact?fromType=controlPad');
        }
      } else {
        this.$router.push('/thunder/interact?fromType=controlPad');
      }
    },
    goInteract(path, isjinzhu) {
      if (isjinzhu) {
        this.$sendLog({
          event_type: 'click',
          event_name: '遥控页',
          event_data: {
            action: '金主包场',
            is_vip: this.is_vip ? 'vip' : '非vip',
          },
        });
      }
      if (path.includes('/thunder/openvip')) {
        this.$sendLog({
          event_type: 'click',
          event_name: '点击按钮',
          event_data: {
            name: '查看更多',
            page: '遥控',
          },
        });
      }
      this.$router.push(path);
    },
    async handleOperate(text, num) {
      if (!this.is_bind) {
        return this.$store.commit('SAVE_SHOW_SCODE_BOX', true);
      }
      let type = num || 0;
      if (text !== 'control' && text !== 'mmic' && text !== 'mvol') {
        type = 0;
      }
      if (text === 'mmic' && this.have_mic === 0) {
        return this.$messageBox.alert('暂不支持该功能');
      }
      if (text === 'control' && this.have_score === 0) {
        return this.$messageBox.alert('暂不支持该功能');
      }
      if (text === 'announcer') {
        return this.operateAnnouncer()
      }
      let desc = get(CONTROL_DESC[text], 'desc', '')
      this.$sendLog({
        event_type: 'click',
        event_name: '遥控组件',
        event_data: {
          desc,
        },
      })
      const params = {
        openid: this.openid,
        unionid: this.unionid,
        type,
      };
      if (text === 'next') {
        params.is_vip = this.is_vip ? 1 : 0;
        params.type = undefined;
        this.handleNext(params, text);
        return;
      }
      const res = await http.get(`https://k.ktvsky.com${apis.song}${text}`, { params })
      this.handleOperateCallback(res, text, desc);
    },
    handleNext(params, text) {
      chttp
        .get('/vod/song/next', {
          params,
        })
        .then((res) => {
          this.handleOperateCallback(res, text);
        })
        .catch((e) => {
          this.$messageBox.alert(e, '');
        });
    },
    handleOperateCallback(res, text, desc) {
      const { tip = desc } = get(CONTROL_DESC, text, {})
      const errcode = get(res, 'errcode');
      if (errcode === 21001) {
        this.$toast(tip);
        if (text === 'next') {
          this.$store.dispatch('getOrderedSongNum', -1);
        }
        if (text === 'control') {
          this.score = this.score === 1 ? 0 : 1;
        }
      } else if (errcode === 34567) {
        this.$store.commit('SHOW_VIP_RIGHTS');
      } else if (errcode === 40003) {
        return this.$store.commit('SAVE_SHOW_SCODE_BOX', true);
      }
    },
    handleClickActive(key, imgurl, num, txt) {
      const data = {
        pagename: '遥控',
        key,
        imgurl,
        num,
        txt,
      };
      this.$store.dispatch('handleShow', data);
    },
    toOrder() {
      this.$sendLog({
        event_type: 'click',
        event_name: this.nextMySong.songid ? '点击去置顶' : '点击查看更多已点',
        event_data: {
          name: '遥控页',
        },
      })
      if (this.$route.name === 'orderedSong') {
        return this.closePad()
      }
      const fr = this.nextMySong.songid ? 'Top' : 'More'
      this.$router.push(`/thunder/ordered?fr=control${fr}`)
    },
    async getAnnouncerStatus() {
      const params = {
        ktvid: this.ktvid,
        mac: this.Mac,
        openid: this.openid,
        unionid: this.unionid,
        roomid: this.roomid,
      }
      const { result = {} } = await chttp.get('/vodc/thunder/h5bmannounceconfig', { params })
      this.announcerStatus = get(result, 'action.all', 0)
      this.announcerDefault = get(result, 'action.default', 1)
    },
    async getAnnouncerAction() {
      const params = {
        unionid: this.unionid,
      }
      const result = await http.get('https://k.ktvsky.com/bar/u/remote_ctrl/song/announcetype', { params })
      if (result.data) {
        this.announcerAction = get(result, 'data.status', 0)
      } else {
        this.announcerAction = this.announcerDefault
      }
    },
    async operateAnnouncer() {
      if (this.announcerAction == 1) {
        this.$messageBox.confirm('关闭后演唱不再报幕', '').then(() => {
          this.$sendLog({
            event_mode: 'eventVod',
            event_data: {
              event_name: 1011,
            },
          })
          this.handleAction()
        }).catch(() => {
          this.$messageBox.close();
        });
      } else {
        this.$sendLog({
          event_mode: 'eventVod',
          event_data: {
            event_name: 1012,
          },
        })
        this.handleAction()
      }
    },
    async handleAction() {
      const action = this.announcerAction == 1 ? 0 : 1
      const params = {
        unionid: this.unionid,
        openid: this.openid,
        action,
      }
      const res = await http.get('https://k.ktvsky.com/bar/u/remote_ctrl/song/announce', { params })
      if (res.errcode == 21001) {
        this.announcerAction = action
        const message = this.announcerAction == 0 ? '关闭成功，下一首歌起不展示报幕' : '开启成功，下一首歌起开始报幕';
        this.$toast({
          message,
          duration: 3000,
        })
      } else {
        this.$toast({
          message: '网络链接失败，请重试',
          duration: 3000,
        })
      }
    },
    handleMask() {
      this.$sendLog({
        event_type: 'click',
        event_name: '欢乐歌房入口点击',
        event_data: {
          action: '遥控页',
        },
      })
      window.location.href = 'https://sj.qq.com/appdetail/com.thunder.tv?&from_wxz=1';
    },
  },
  async mounted() {
    await this.getAnnouncerStatus()
    if (this.announcerStatus) {
      this.getAnnouncerAction()
    }
    reportPay({
      page_tp: 3,
      active_tp: 3,
    });
    // 非vip用户第二次及之后点击遥控时，展示5.9开通会员入口
    this.isManualControl = this.$store2.get('padNormalControl') || 0;
    this.dialogToastCnt = this.$store2.get('dialogToastCnt') || 0;
    this.dialogToastCnt++;
    this.$store2.set('dialogToastCnt', this.dialogToastCnt);
    const isHour = 1000 * 60 * 60 * 3;
    if (this.isManualControl >= 2) {
      this.isFold = false;
      if (Date.now() - this.$store2.get('padNormalStartTime') < isHour) {
        this.isFold = true;
        return;
      }
      this.isManualControl = 0;
      this.$store2.remove('padNormalControl');
      this.$store2.remove('padNormalStartTime');
      this.$store2.remove('dialogToastCnt');
    }
    this.isManualControl++;
    // 如果是非VIP 并且没有找到开始时间时 设置
    if (!this.vip && !this.$store2.get('padNormalStartTime')) {
      this.$store2.set('padNormalControl', this.isManualControl);
      this.isFold = false;
      if (this.isManualControl >= 2) {
        this.$store2.set('padNormalStartTime', Date.now());
      }
    }
  },
  created() {
    // (点击遥控按钮时拉取最新的isTime)12小时内开通过vip的用户遥控页不再显示续费弹窗
     this.$store.dispatch('getHomeConfig', {
         isPop: true,
         callback: () => {},
     })
  },
};
</script>
<style lang="scss" scoped>
@keyframes lift-in {
  0% {
    bottom: -900px;
  }
  100% {
    bottom: 0;
  }
}
.control-pad {
  z-index: $z_index_two;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  &.is-footer {
    bottom: 110px;
  }
  .top-effect {
    z-index: 1;
    width: 319px;
    height: 100px;
    right: 0px;
    position: absolute;
  }
}
.control-wrapper {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
  animation: lift-in 0.5s;
}
.container {
  width: 100%;
}
.increment-box {
  display: flex;
  border-radius: 15px;
  .vip-gold{
    width: 750px;
    height: 250px;
  }
}
html[data-dpr="2"] {
  @media screen and (max-width: 640px) {
    .pad-wrap {
      padding: 30px;
    }
  }
}
.new-control-pad{
  background: rgba(0, 0, 0, 0.7);
  z-index: 1000;
}
.operate-box {
  position: relative;
  width: 750px;
  height: 450px;
  background: #ffffff;
  overflow: hidden;
  padding: 10px 29px 0px;
  .song-info{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 10px;
    button{
      width: 170px;
      color: rgba(0, 0, 0, 0.7);
    }
  }
  .operate-btn {
    margin-top: 20px;

    .row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    .row-first {
      justify-content: space-between;
    }

    .control-btn {
      width: 220px;
      height: 120px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .voice {
      width: 456px;
      height: 100px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;
      button {
        width: 84px;
        height: 84px;
        &:first-child{
          position: absolute;
          top: 8px;
          left: 8px;
        }
        &:last-child{
          position: absolute;
          top: 8px;
          right: 8px;
        }
      }
      .volume-name {
        width: 100%;
        height: 100%;
        object-fit: contain;
        flex-shrink: 0;
      }
    }
  }
}
.operate-box-vip {
  padding: 24px 35px 30px;
}
.operate-box-role5 {
  height: 500px;
  padding: 0px 29px;
  .mask-box {
    width: 100%;
    height: 80px;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}
.top-cancel-btn {
  position: fixed;
  top: 30px;
  right: 15px;
  width: 50px;
  height: 50px;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
